import ROUTES from '../routes'

const fullWidthPages = [ROUTES.noHomes, ROUTES.notFound]

export const isFullWidthPage = (pathname: string): boolean => fullWidthPages.includes(pathname)
